import React from "react";
import {
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Table,
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {

        const { supplierWiseData, routeWiseData, dataType, selectedSearchValues } = this.props

        const routeWiseColumns = [
            { id: "routeName", label: "Route" },
            { id: "totalNetWeight", label: "Crop Weight (KG)" },
            { id: "gross", label: "Gross" },
            { id: "totalAddition", label: "Addition Pay" },
            { id: "coinBF", label: "Coins" },
            { id: "transport", label: "Transport" },
            { id: "debtsBF", label: "B/F Debts" },
            { id: "fertilizerBF", label: "B/F Fertilizer" },
            { id: "advancePayment", label: "Advance" },
            { id: "teaDeduction", label: "Tea" },
            { id: "fertilizerDeductions", label: "Fertilizer" },
            { id: "festivalAdvance", label: "Festival Advance" },
            { id: "chemicalDeductions", label: "Chemical" },
            { id: "mealDeduction", label: "Meal" },
            { id: "loanPayment", label: "Loan" },
            { id: "stamp", label: "Stamp" },
            { id: "otherDeductions", label: "Other" },
            { id: "bankCharge", label: "Bank Charge" },
            { id: "totalDeductions", label: "Total Deductions" },
            { id: "balance", label: "Balance" },
            { id: "debtsCF", label: "C/F Debts" },
            { id: "fertilizerCF", label: "C/F Fertilizer" },
            { id: "loanBalance", label: "Loan Balance" },
            { id: "cash", label: "Cash" },
            { id: "bank", label: "Bank" },
            { id: "coinCF", label: "C/F Coins" }
        ];

        const supplierWiseColumns = [
            { id: "registrationNumber", label: "Reg. No." },
            { id: "customerName", label: "Supplier Name" },
            { id: "totalNetWeight", label: "Crop Weight (KG)" },
            { id: "gross", label: "Gross" },
            { id: "totalAddition", label: "Addition Pay" },
            { id: "coinBF", label: "Coins" },
            { id: "transport", label: "Transport" },
            { id: "debtsBF", label: "B/F Debts" },
            { id: "fertilizerBF", label: "B/F Fertilizer" },
            { id: "advancePayment", label: "Advance" },
            { id: "teaDeduction", label: "Tea" },
            { id: "fertilizerDeductions", label: "Fertilizer" },
            { id: "festivalAdvance", label: "Festival Advance" },
            { id: "chemicalDeductions", label: "Chemical" },
            { id: "mealDeduction", label: "Meal" },
            { id: "loanPayment", label: "Loan" },
            { id: "stamp", label: "Stamp" },
            { id: "otherDeductions", label: "Other" },
            { id: "bankCharge", label: "Bank Charge" },
            { id: "totalDeductions", label: "Total Deductions" },
            { id: "balance", label: "Balance" },
            { id: "debtsCF", label: "C/F Debts" },
            { id: "fertilizerCF", label: "C/F Fertilizer" },
            { id: "loanBalance", label: "Loan Balance" },
            { id: "cash", label: "Cash" },
            { id: "bank", label: "Bank" },
            { id: "coinCF", label: "C/F Coins" }
        ];

        let collectionTypeIDArray = [];

        supplierWiseData.map((item) => {
            item.cropDetails.forEach(element => {
                collectionTypeIDArray.push({ collectionTypeID: element.collectionTypeID, collectionTypeName: element.collectionTypeName + ' Rate' });
            });
        });

        const collectionTypeIDs = [...new Map(collectionTypeIDArray.map(item => [item['collectionTypeID'], item])).values()];

        collectionTypeIDs.map((item) => {
            supplierWiseColumns.splice(2, 0, { id: item.collectionTypeID, label: item.collectionTypeName })
        })

        const totals = (dataType === 'supplierWise' ? supplierWiseColumns : routeWiseColumns).reduce((acc, column) => {
            if (column.id !== "routeName") {
                acc[column.id] = (dataType === 'supplierWise' ? supplierWiseData : routeWiseData).reduce((sum, row) => sum + (row[column.id] || 0), 0);
            }
            return acc;
        }, {});

        return (
            <div>

                <h2><center><u>{dataType === 'supplierWise' ? "Route Wise Balance Payment Detail Report" : "Route Wise Balance Payment Summary Report"}</u></center></h2>
                <div>&nbsp;</div>
                <h2><center>{"Group: " + selectedSearchValues.groupName}</center></h2>
                <h2><center>{"Factory: " + selectedSearchValues.factoryName}</center></h2>
                <h3><center>{dataType === 'supplierWise' ? "Route: " + selectedSearchValues.routeName : "Route: All Routes"} </center></h3>
                <h3><center>{selectedSearchValues.month + " - " + selectedSearchValues.year} </center></h3>
                <div>&nbsp;</div>
                <div>
                    {dataType === 'supplierWise' ? (
                        <>
                            <Table size="small" aria-label="simple table" style={{ fontFamily: "sans-serif" }}>
                                <TableHead>
                                    <TableRow>
                                        {supplierWiseColumns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}
                                                align="center"
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {supplierWiseData.map((row, index) => (
                                        <TableRow key={index}>
                                            {supplierWiseColumns.map((column) => (
                                                typeof (column.id) === "number" ? (
                                                    <TableCell
                                                        key={column.id}
                                                        style={{ border: "1px solid black", padding: '2px' }}
                                                        align="right"
                                                    >
                                                        {row.balanceRates.find(item => item.collectionTypeID == column.id) !== undefined ?
                                                            (row.balanceRates.find(item => item.collectionTypeID == column.id)).rate :
                                                            "0"
                                                        }
                                                    </TableCell>) :
                                                    (<TableCell
                                                        key={column.id}
                                                        style={{ border: "1px solid black", padding: '2px' }}
                                                        align={typeof (row[column.id]) === "number" ? "right" : "left"}
                                                    >
                                                        {column.id === "registrationNumber" || column.id === "customerName" ?
                                                            row[column.id] :
                                                            Number(row[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        }
                                                    </TableCell>)
                                            ))}
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        {supplierWiseColumns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                style={{ border: "1px solid black", fontWeight: "bold", padding: '2px' }}
                                                align={typeof (totals[column.id]) === "number" ? "right" : "left"}
                                            >
                                                {column.id === "registrationNumber"
                                                    ? "Total"
                                                    : column.id === "customerName"
                                                        ? " "
                                                        : typeof (column.id) === "number" ? " " :
                                                            Number(totals[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </>
                    ) :
                        (
                            <>
                                <Table size="small" aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            {routeWiseColumns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}
                                                    align="center"
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {routeWiseData.map((row, index) => (
                                            <TableRow key={index}>
                                                {routeWiseColumns.map((column) => (
                                                    <TableCell
                                                        key={column.id}
                                                        style={{ border: "1px solid black", padding: '2px' }}
                                                        align={typeof (row[column.id]) === "number" ? "right" : "left"}
                                                    >
                                                        {
                                                            typeof (row[column.id]) === 'string' ?
                                                                row[column.id] :
                                                                Number(row[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        }
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            {routeWiseColumns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    style={{ border: "1px solid black", fontWeight: "bold", padding: '2px' }}
                                                    align={typeof (totals[column.id]) === "number" ? "right" : "left"}
                                                >
                                                    {column.id === "routeName" ? "Total" : Number(totals[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </>
                        )}
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );
    }
}